import { IPitch } from "../../../../../common/types";

export const getAlternates = (alternatedPitches: IPitch[]) => {
    let hasSharp = false;
    let hasFlat = false;
    alternatedPitches.forEach(alternatedPitch => {
        if (alternatedPitch.a === 1) {
            hasSharp = true;
        } else if (alternatedPitch.a === -1) {
            hasFlat = true;
        }
    });
    return {
        hasSharp,
        hasFlat,
    };
};